module.exports = {
  "id": "zuzo",
  "title": "zuzo",
  "image": "provision/parts/zuzo/zuzo.png",
  "info": [
    {
      "text": "It's zuzo!",
      "image": "provision/parts/zuzo/zuzo.png"
    }
  ],
  "exposedVariables": []
};